import { useTranslation } from 'react-i18next';
import { ScrollArea } from './ui/scroll-area';
import SafeHtml from './SafeHtml';

type TRefundGiftSheetTerms = {
  description?: string;
  terms?: string;
  disclaimer?: string;
};

const RefundGiftSheetTerms = ({
  description,
  terms,
  disclaimer,
}: TRefundGiftSheetTerms) => {
  const { t } = useTranslation();
  const titleClasses = 'font-bold text-secondary-foreground py-3';

  return (
    <div className='mt-4 flex-1 overflow-hidden'>
      <ScrollArea className='flex h-full flex-col gap-4 rounded-md bg-secondary p-4'>
        {description && (
          <div>
            <h5 className={titleClasses}>{t('Description')}</h5>
            <SafeHtml html={description} className='text-muted-foreground' />
          </div>
        )}
        {terms && (
          <div>
            <h5 className={titleClasses}>{t('Terms')}</h5>
            <SafeHtml html={terms} />
          </div>
        )}
        {disclaimer && (
          <div>
            <h5 className={titleClasses}>{t('Disclaimer')}</h5>
            <SafeHtml html={disclaimer} />
          </div>
        )}
      </ScrollArea>
    </div>
  );
};

export default RefundGiftSheetTerms;
